import type { JSONContent } from '@tiptap/core'
import z from 'zod'

export type { JSONContent as TiptapContent }

export const tiptapContentSchema = z
  .record(z.string(), z.unknown())
  .transform(v => v as JSONContent)
